<ng-container *ngIf="field !== 'serviceLevel'; else serviceLevelTemplate">
  <kendo-dropdownlist
    *ngIf="!multiple; else multiSelect"
    style="width: 100%; margin: 0; padding: 8px 12px 4px 12px;"
    [data]="data"
    (valueChange)="onChange($event)"
    [defaultItem]="defaultItem"
    [value]="selectedValue"
    [valuePrimitive]="true"
    [textField]="textField"
    [valueField]="valueField"
  >
  </kendo-dropdownlist>
</ng-container>

<ng-template #multiSelect>
  <kendo-multiselect
    style="width: 100%; margin: 0; padding: 8px 12px 4px 12px;"
    [data]="data"
    (valueChange)="onChange($event)"
    [value]="selectedValue"
    [valuePrimitive]="true"
    [textField]="textField"
    [valueField]="valueField"
    [popupSettings]="{ width: 'auto', minWidth: 250 }"
    [placeholder]="'Select...'"
  >
  </kendo-multiselect>
</ng-template>

<ng-template #serviceLevelTemplate>
  <kendo-dropdownlist
    *ngIf="!multiple; else multiSelectServiceLevel"
    style="width: 100%; margin: 0; padding: 8px 12px 4px 12px;"
    [popupSettings]="{ height: 200, width: 300 }"
    [data]="serviceLevelData"
    [defaultItem]="defaultItem"
    (valueChange)="onChange($event)"
    [value]="selectedValue"
    [valuePrimitive]="true"
    [textField]="textField"
    [valueField]="valueField"
  >
    <ng-template kendoDropDownListItemTemplate let-dataItem>
      <div
        class="dropdown-list-item"
        style="white-space: nowrap;"
        [style.background-color]="dataItem.bgColor"
        [style.color]="getContrastYIQ(dataItem.bgColor)"
      >
        <span class="pl-2">{{ dataItem.display }}</span>
      </div>
    </ng-template>
  </kendo-dropdownlist>
</ng-template>

<ng-template #multiSelectServiceLevel>
  <kendo-multiselect
    style="width: 100%; margin: 0; padding: 8px 12px 4px 12px;"
    [data]="serviceLevelData"
    (valueChange)="onChange($event)"
    [value]="selectedValue"
    [valuePrimitive]="true"
    [textField]="textField"
    [valueField]="valueField"
    [autoClose]="false"
    [popupSettings]="{ height: 200, width: 300 }"
  >
    <ng-template kendoMultiSelectItemTemplate let-dataItem>
      <div
        class="dropdown-list-item"
        style="white-space: nowrap;"
        [style.background-color]="dataItem.bgColor"
        [style.color]="getContrastYIQ(dataItem.bgColor)"
      >
        <span class="pl-2">{{ dataItem.display }}</span>
      </div>
    </ng-template>
  </kendo-multiselect>
</ng-template>
